import { IFacility } from "redux/reducers/models/facility";

/**
 * Whether the "Restrict gift card to facility" product option should be shown.
 * Only relevant for multi-facility clients where the current facility is not marked single.
 */
export function showGiftCardRestrictFacilityToggle(
  facility?: IFacility,
  clientFacilities?: IFacility[] | null,
): boolean {
  return facility?.is_single_facility === false && (clientFacilities?.length ?? 0) > 1;
}
